import { CountdownPosition, TimerType } from '@/types';
import TimerCreationWizardModal from '@components/templates/TimerCreationWizardModal';
import type { TimerTemplateId } from '@lib/timerTemplates';

type TemplateSelectionModalProps = {
	isOpen: boolean;
	onOpenChange: (isOpen: boolean) => void;
	onSelect: (
		templateId: TimerTemplateId,
		countdownPosition: CountdownPosition | undefined,
		timerType: TimerType,
	) => void;
};

export default function TemplateSelectionModal({ isOpen, onOpenChange, onSelect }: TemplateSelectionModalProps) {
	return (
		<TimerCreationWizardModal
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			onSelect={({ templateId, countdownPosition, timerType }) => onSelect(templateId, countdownPosition, timerType)}
		/>
	);
}
